// extracted by mini-css-extract-plugin
module.exports = {"socialThumbnails":"styles_socialThumbnails__6PcZO","svg":"styles_svg__D8nvo"};